import React from "react";
import "./acceptedChallengeEvent.style.scss";

const AcceptedChallengeEvent = ({ eventTitle, eventNumber, eventsTotal, eventTime, handleDayClick, boolean, booleanIndex, indexOfDay, dateIndex, dayString, dateString, toggleDone, date }) => {

    return (
        <div className={`accepted-challenge-event${boolean === true ? `-done` : ''}`}>
            <div
                className="left"
                onClick={() => toggleDone(booleanIndex)}
            >
                <div className="event-time">
                    {
                        boolean === true ? (
                            <p><strong>Done</strong></p>
                        ) : (
                            <p>{eventTime}</p>
                        )
                    }
                </div>
                <div className="main">
                    <div className="event-title">
                    <p>{eventTitle && eventTitle.length > 20 ? `${eventTitle.substring(0, 20)}...` : eventTitle}</p>
                    {/* <p>{eventTitle}</p> */}
                    </div>
                    <div className="subtitle">
                        <p>{eventNumber} of {eventsTotal}</p>
                    </div>
                </div>
            </div>
            <div className="right">
                <div className="days">
                    <div
                        className={`day${indexOfDay === 1 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(0, dateIndex, boolean, date)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 1 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0, fontSize: 'small', fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 2 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(1, dateIndex, boolean, date)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 2 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0, fontSize: 'small', fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 3 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(2, dateIndex, boolean, date)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 3 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0, fontSize: 'small', fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 4 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(3, dateIndex, boolean, date)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 4 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0, fontSize: 'small', fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 5 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(4, dateIndex, boolean, date)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 5 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0, fontSize: 'small', fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 6 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(5, dateIndex, boolean, date)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 6 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0, fontSize: 'small', fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 0 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(6, dateIndex, boolean, date)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 0 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0, fontSize: 'small', fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                </div>
                {/* <div className="days">
                    <div
                        className={`day${indexOfDay === 1 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(0, dateIndex, boolean, date)}
                    >
                    </div>
                    <div
                        className={`day${indexOfDay === 2 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(1, dateIndex, boolean, date)}
                    >
                    </div>
                    <div
                        className={`day${indexOfDay === 3 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(2, dateIndex, boolean, date)}
                    >
                    </div>
                    <div
                        className={`day${indexOfDay === 4 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(3, dateIndex, boolean, date)}
                    >
                    </div>
                    <div
                        className={`day${indexOfDay === 5 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(4, dateIndex, boolean, date)}
                    >
                    </div>
                    <div
                        className={`day${indexOfDay === 6 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(5, dateIndex, boolean, date)}
                    >
                    </div>
                    <div
                        className={`day${indexOfDay === 0 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(6, dateIndex, boolean, date)}
                    >
                    </div>
                </div> */}
                <div
                    className="info-right"
                    onClick={() => toggleDone(booleanIndex)}
                >
                    <p><strong>{dayString}</strong> · {dateString}</p>
                </div>
            </div>
        </div>
    );
};

export default AcceptedChallengeEvent;